/* unplugin-vue-components disabled */import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import * as echarts from "echarts/core";
import { TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, DataZoomComponent } from "echarts/components";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { nextTick, watch } from "vue";
export default {
  __name: 'chartMain',
  props: ["option", "name"],
  setup(__props) {
    var props = __props;
    echarts.use([TitleComponent, ToolboxComponent, TooltipComponent, GridComponent, LegendComponent, LineChart, BarChart, PieChart, CanvasRenderer, UniversalTransition, DataZoomComponent]);
    var myChart = ref(null);
    watch(() => {
      return props.option;
    }, val => {
      nextTick(() => {
        console.log("在子组件中打印options=====", val);
        var el = myChart.value;
        if (echarts.getInstanceByDom(el)) {
          var mychart_ = echarts.getInstanceByDom(el);
          window.addEventListener("resize", () => {
            //监听浏览器窗口大小
            mychart_.resize();
          });
          props.option && mychart_.setOption(props.option);
        } else {
          var _mychart_ = echarts.init(el);
          window.addEventListener("resize", () => {
            //监听浏览器窗口大小
            _mychart_.resize();
          });
          props.option && _mychart_.setOption(props.option);
        }
      });
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: _unref(props).name,
        class: "box",
        ref_key: "myChart",
        ref: myChart
      }, null, 8, _hoisted_1);
    };
  }
};